module.exports = __webpack_public_path__ + "static/raw-127faa952479e1be0cb9c247a9df2424.png";